import { render, staticRenderFns } from "./authorityComponent.vue?vue&type=template&id=4c2c7ecf&scoped=true&"
import script from "./authorityComponent.vue?vue&type=script&lang=js&"
export * from "./authorityComponent.vue?vue&type=script&lang=js&"
import style0 from "./authorityComponent.vue?vue&type=style&index=0&id=4c2c7ecf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c7ecf",
  null
  
)

export default component.exports